import React from 'react';
import type { DistanceInsight } from '../types';

const LEVEL_COLOR: Record<DistanceInsight['target_level'], string> = {
  ideal:        'text-leaf-700',
  acceptable:   'text-brand-700',
  hard:         'text-amber-700',
  unrealistic:  'text-rose-700',
  unknown:      'text-slate-500',
};

const DistanceInsightSection: React.FC<{ data: DistanceInsight; station: string }> = ({ data, station }) => {
  const tone = LEVEL_COLOR[data.target_level];
  return (
    <section className="py-4 border-b border-slate-200">
      <div className="flex items-baseline justify-between mb-3 flex-wrap gap-2">
        <h3 className="text-[13px] font-semibold text-slate-900">駅距離による有利不利</h3>
        <span className="text-[11px] text-slate-500">関連性・距離・知名度の3要素のうち「距離」軸の評価</span>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-3 mb-4 pb-4 border-b border-slate-100">
        <div>
          <div className="text-[11px] text-slate-500 mb-1">貴店から{station}駅</div>
          <div className={`text-xl font-semibold tabular-nums leading-none ${tone}`}>{data.target_distance_m} m</div>
          <div className={`text-[11px] mt-1 ${tone}`}>{data.target_label}</div>
        </div>
        {data.top3_avg_distance_m !== null && (
          <div>
            <div className="text-[11px] text-slate-500 mb-1">上位3店舗の平均</div>
            <div className="text-xl font-semibold tabular-nums text-slate-900 leading-none">{data.top3_avg_distance_m} m</div>
            <div className="text-[11px] text-slate-500 mt-1">最近接 {data.top3_closest_distance_m} m</div>
          </div>
        )}
        <div>
          <div className="text-[11px] text-slate-500 mb-1">距離による不利度</div>
          <div className={`text-xl font-semibold tabular-nums leading-none ${tone}`}>
            {data.relevance_handicap_pct === 0 ? '無し' : `-${data.relevance_handicap_pct}%`}
          </div>
          <div className="text-[11px] text-slate-500 mt-1">関連性スコア概算</div>
        </div>
      </div>

      {data.top3_distances.length > 0 && (
        <div className="mb-4 pb-4 border-b border-slate-100">
          <h4 className="text-[11px] font-semibold text-slate-700 mb-2">上位3店舗の駅距離</h4>
          <div className="space-y-1 text-[12px]">
            {data.top3_distances.map((d) => (
              <div key={d.title} className="flex items-baseline justify-between">
                <span className="text-slate-700 truncate">
                  <span className="text-slate-400 mr-1">{d.rank}位</span>{d.title}
                </span>
                <span className="tabular-nums text-slate-600 shrink-0 ml-2">{d.distance_m} m</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div>
        <div className={`text-[11px] font-semibold mb-1 ${tone}`}>診断 — {data.verdict}</div>
        <p className="text-[12px] text-slate-700 leading-relaxed">{data.recommendation}</p>
      </div>
    </section>
  );
};

export default DistanceInsightSection;
